<template>
  <transition name="dwp--fade">
    <i-frame id="dwp--wrapper" v-if="open">
      <SignIn v-if="!loggedIn" />
      <Tasks v-else-if="subscription" />
      <SubscriptionEnded v-else />
    </i-frame>
  </transition>
</template>

<script>
import store from "@/store";
import { sync, get } from "vuex-pathify";

export default {
  store,

  computed: {
    open: sync("ui/open"),
    signIn: sync("ui/modal@signIn"),
    loggedIn: get("user/user@loggedIn"),
    user: get("user/data"),
    analytics: sync("ui/modal@analytics"),
    subscription: get("user/user@data.subscription"),
  },

  mounted() {
    this.installId();
  },

  watch: {
    user(val) {
      if (val) {
        this.analyticsSetting();
      }
    },
  },

  components: {
    SignIn: () => import("@/components/SignIn.vue"),
    SubscriptionEnded: () => import("@/components/SubscriptionEnded.vue"),
    SupportLinks: () => import("@/components/SupportLinks.vue"),
    iFrame: () => import("@/components/ui/iFrame.vue"),
    Tasks: () => import("./components/Tasks.vue"),
  },

  methods: {
    settings() {
      this.analyticsSetting();
      this.installId();
    },

    analyticsSetting() {
      let opt = jQuery(".dwp-analytics-opt-out").attr(
          "data-cy",
          "usage-setting"
        ),
        text = this.user.analytics
          ? "Opt Out Of Usage Tracking"
          : "Opt In To Usage Tracking";

      if (this.user.analytics !== undefined) {
        opt.text(text);
      }

      // settings
      opt.on("click", (e) => {
        e.preventDefault();
        this.analytics = true;
        this.open = true;
      });
    },

    installId() {
      let button = jQuery("#dwp_uninstall_id")
        .text("Regenerate Project ID")
        .attr("data-cy", "regenerate-project");
      let old = button.text();

      button.on("click", async (e) => {
        e.preventDefault();
        let r = confirm(
          "Are you sure you want to do this? There's no way to get your previous project back!"
        );

        if (r) {
          button.text("Regenerating...");
          try {
            let [response] = await this.$http.post(docketData.ajaxUrl, {
              data: {
                action: "dwp-regenerate-project-id",
                nonce: docketData.nonce,
              },
            });

            if (!response?.data) {
              throw new Error("Something went wrong");
            }

            jQuery("#dwp-project-id").text(response?.data);
            button.text("Regenerate Project ID");
            window.location.reload();
          } catch (e) {
            console.error(e);
          }

          // success: (data) => {
          //     con
          // },
          // complete: () => {
          //   // window.location.reload();
          //   return;
          // },
          // },
          // });
        }
      });
    },
  },
};
</script>

<style>
#dwp--wrapper {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 999999999 !important;
}
.dwp--fade-enter-active,
.dwp--fade-leave-active {
  transition: opacity 0.2s;
}
.dwp--fade-enter, .dwp--fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>